import { render } from "./FeatInfoEventBox.vue?vue&type=template&id=16c03988&scoped=true"
import script from "./FeatInfoEventBox.vue?vue&type=script&lang=js"
export * from "./FeatInfoEventBox.vue?vue&type=script&lang=js"

import "./FeatInfoEventBox.vue?vue&type=style&index=0&id=16c03988&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c03988"]])

export default __exports__